import React from "react";
import { IonCol, IonRow } from "@ionic/react";
import classNames from "classnames/bind";
import styles from "./ReferralPoints.module.scss";
import useGetReferralPointsQuery from "../../providers/referrals/useGetReferralPointsQuery";
import { useAuth } from "../../contexts/auth-context/AuthContextProvider";
import { useConfig } from "../../providers/config";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const ReferralPoints: React.FC<{ className?: string }> = ({ className }) => {
  const config = useConfig();
  const { t } = useTranslation();
  const { user } = useAuth();
  const userId = user?.id;

  const isGetReferralPointsQueryEnabled = config.isReferralEnabled && !!userId;

  const { data: referralPoints, isLoading: isReferralPointsLoading } = useGetReferralPointsQuery({
    userId: userId!,
    options: {
      enabled: isGetReferralPointsQueryEnabled,
    },
  });

  if (isReferralPointsLoading) {
    return null;
  }

  return (
    <IonRow className={cx("referral-points", className)}>
      <IonCol>
        <h2>
          {t("Points")} {referralPoints}
        </h2>
      </IonCol>
    </IonRow>
  );
};

export default ReferralPoints;
